import axios from 'axios';
import { getQueryString } from '@vue/store/helpers';

/**
 * 
 * @param {string} term The part of the address that has already been typed.
 * @returns {promise}
 */
export const autocomplete = ({ term, addressOnly = false }) => {
  return new Promise((resolve, reject) => {
    try {
      let requestURL = '/api/getSearchSuggestions';
      let params = {
        term,
        address_only: addressOnly
      };
      let queryString = getQueryString(params);

      requestURL += `?${queryString}`;

      let config = {
        // transformRequest: [(data, headers) => {
        //   // SmartyStreets rejects the request if you dont remove these headers
        //   delete headers.common['X-CSRF-TOKEN'];
        //   delete headers.common['X-Requested-With'];
        //   return data;
        // }],
        transformResponse: [(data) => {
          /**
           * Need to add an id to each result so that the UI has a uid for each record. street_line had duplicates
           */
          let res = JSON.parse(data);
          // if(!res.suggestions) return res;
          // res.suggestions = res.suggestions.map((suggestion, index) => {
          //   let newSuggestion = {...suggestion};
          //   newSuggestion.id = index;
          //   return newSuggestion;
          // });
          // console.log();
          return res;
        }]
      };
      axios.get(requestURL, config)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};

/**
 * 
 * @param {string} placeId The ID of the google places record we want to query details for
 * @returns {promise}
 */
export const getPlacesDetails = ({ placeId }) => {
  return new Promise((resolve, reject) => {
    try {
      let requestURL = '/api/getPlacesDetails';
      let params = {
        place_id: placeId
      };
      let queryString = getQueryString(params);

      requestURL += `?${queryString}`;

      axios.get(requestURL)
        .then(response => resolve(response))
        .catch(err => reject(err));
    } catch (error) {
      reject(error);
    }
  });
};